export const siteStats = [
  { label: '已收录奇闻', value: '9,480+', icon: 'ri-archive-line' },
  { label: '今日更新', value: '36 条', icon: 'ri-flashlight-line' },
  { label: '瓜友在线', value: '12,760', icon: 'ri-group-line' },
  { label: '平均阅读时长', value: '4.6 分钟', icon: 'ri-time-line' },
];

export const marqueeItems = [
  '菜市场区块链讲价',
  '共享单车骑行38公里',
  '团建强制跳伞',
  '禁止屋内emo条款',
  '食堂抖勺力学分析',
  '地铁算命式debug',
  'WiFi罚款收到转账',
  '婚礼爱情KPI汇报',
];

export const testimonials = [
  {
    name: '加班到八点的阿凯',
    role: '通勤路上的固定读者',
    text: '每天挤地铁那四十分钟全靠它续命。不是那种硬凑的笑话，是真的一个比一个离谱，看完总觉得自己的日子还挺正常。',
    avatar: 'https://readdy.ai/api/search-image?query=Bold%20flat%20illustration%20avatar%20portrait%20of%20a%20cheerful%20young%20office%20worker%2C%20warm%20cream%20background%2C%20tomato%20red%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=200&height=200&seq=gq-av-01&orientation=squarish',
  },
  {
    name: '爱囤梗的设计师',
    role: '内容收藏狂魔',
    text: '分类做得特别清楚，想找"迷惑行为"就点进去，一刷就是半小时停不下来。而且每篇都有头有尾，不是那种看两行就没了的短梗。',
    avatar: 'https://readdy.ai/api/search-image?query=Bold%20flat%20illustration%20avatar%20portrait%20of%20a%20stylish%20designer%20with%20glasses%2C%20warm%20cream%20background%2C%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=200&height=200&seq=gq-av-02&orientation=squarish',
  },
  {
    name: '深夜刷手机的老周',
    role: '资深瓜农',
    text: '最喜欢"魔幻现实"这个栏目，很多事你明知道是真的，还是忍不住要确认两遍。评论区也很有意思，大家都在认真复盘事件逻辑。',
    avatar: 'https://readdy.ai/api/search-image?query=Bold%20flat%20illustration%20avatar%20portrait%20of%20a%20relaxed%20middle%20aged%20man%20smiling%2C%20warm%20cream%20background%2C%20tomato%20red%20and%20amber%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=200&height=200&seq=gq-av-03&orientation=squarish',
  },
];

export const faqs = [
  {
    q: '猎奇吃瓜主要更新什么内容？',
    a: '我们专注六类内容：奇葩人物、迷惑行为、沙雕新闻、离谱故事、搞笑怪事和魔幻现实。每天更新，取材于公开的趣闻与生活观察，主打一个真实又上头。',
  },
  {
    q: '内容多久更新一次？',
    a: '工作日每天更新三到五次，周末和节假日也会保持一定频率。首页的"最新爆料"会按时间顺序排列，方便你从最新的开始看。',
  },
  {
    q: '怎么快速找到我想看的类型？',
    a: '顶部导航里有"主题分类"，进入分类页后还能按最新、最热、最多点赞排序，也能用关键词搜索标题和标签，几秒就能定位到想看的方向。',
  },
  {
    q: '内容会不会很严肃？',
    a: '不会。我们尽量用轻松的方式把事情讲清楚，但每篇都会交代事情的来龙去脉，不做没有信息量的标题党，也不编造不存在的情节。',
  },
  {
    q: '可以投稿或者推荐好玩的事吗？',
    a: '可以。在"关于我们"页面有联系入口，把你看到的离谱故事发过来，我们核实并整理之后会考虑收录，同时会注明来源方向。',
  },
  {
    q: '网站内容可以转载吗？',
    a: '欢迎分享链接。如需整篇转载，请先通过"关于我们"页面的联系方式取得授权，并保留原文出处说明。',
  },
];

export const principles = [
  {
    icon: 'ri-emotion-happy-line',
    title: '好笑但不刻薄',
    desc: '我们围观离谱的操作和荒唐的场面，但不针对具体的人进行人身攻击。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '有趣但不失真',
    desc: '每个故事都交代清楚起因、经过和结果，不做断章取义的标题党。',
  },
  {
    icon: 'ri-layout-masonry-line',
    title: '轻松但有条理',
    desc: '内容分类清晰、结构完整，让你笑着看完，也知道自己看了什么。',
  },
  {
    icon: 'ri-refresh-line',
    title: '稳定持续更新',
    desc: '保持每天的更新节奏，把零散的瓜整理成可以稳定消费的内容。',
  },
];